const asrsEligible = [
    { id: "Y", label: "Y" },
    { id: "N", label: "N" }
  ]
  
  export const getAsrsEligible = id => asrsEligible.find(asrsEligible => asrsEligible.id === id)
  export const allAsrsEligible = asrsEligible.map(({ id }) => id)
  
  export default asrsEligible